import { IconProps } from "@/types/types";

export default function Plus({ width = "24", height = "24" }: IconProps) {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.7499 19.75C10.7499 20.4403 11.3096 21 11.9999 21C12.6903 21 13.2499 20.4403 13.2499 19.75V13.25H19.75C20.4403 13.25 21 12.6903 21 12C21 11.3096 20.4403 10.75 19.75 10.75H13.2499V4.25C13.2499 3.55965 12.6903 3 11.9999 3C11.3096 3 10.7499 3.55964 10.7499 4.25V10.75H4.25C3.55965 10.75 3 11.3096 3 12C3 12.6903 3.55965 13.25 4.25 13.25H10.7499V19.75Z" fill="currentColor" />
        </svg>

    )
}

